import errorManager from '@/rollbar.js';

const openModal = (element_selector) => {
  eventBus.$on('siatButtonMounted', (data) => {
    const element = document.querySelector(element_selector);
    element.addEventListener('click', (e) => {
      eventBus.$emit('openSiatModal');
    });
  });
};
const init = (element_selector) => {
  try {
    openModal(element_selector);
  } catch (e) {
    errorManager(e);
  }
};

window.SiatModalActivation = {
  init: init,
};
